var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYourUbi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 0.5C6.81279 0.50266 4.71591 1.37271 3.16932 2.91931C1.62272 4.46591 0.752668 6.56278 0.750009 8.75C0.747426 10.5374 1.33136 12.2764 2.41223 13.7C2.41223 13.7 2.63723 13.9959 2.67338 14.0388L9.00001 21.5L15.3293 14.0355C15.3626 13.9956 15.5878 13.6997 15.5878 13.6997L15.5889 13.6979C16.6691 12.2748 17.2527 10.5366 17.25 8.75C17.2473 6.56278 16.3773 4.46591 14.8307 2.91931C13.2841 1.37271 11.1872 0.50266 9.00001 0.5ZM9.00001 11.75C8.40666 11.75 7.82664 11.5741 7.3333 11.2444C6.83995 10.9148 6.45543 10.4462 6.22837 9.89805C6.00131 9.34987 5.9419 8.74667 6.05765 8.16473C6.17341 7.58279 6.45913 7.04824 6.87869 6.62868C7.29824 6.20912 7.83279 5.9234 8.41474 5.80764C8.99668 5.69189 9.59988 5.7513 10.1481 5.97836C10.6962 6.20542 11.1648 6.58994 11.4944 7.08329C11.8241 7.57664 12 8.15666 12 8.75C11.9991 9.54537 11.6828 10.3079 11.1203 10.8703C10.5579 11.4327 9.79538 11.7491 9.00001 11.75Z",
    fill: "#0058D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYourUbi);
export default __webpack_public_path__ + "static/media/Ic_your_ubi.00a927d47f8159636163f160c5acd19a.svg";
export { ForwardRef as ReactComponent };